module.exports = __webpack_public_path__ + "static/img2-bbafa9efaa9870f7f5bc7930668eb28d.jpg";